import { IconType } from 'react-icons';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import Spinner from '@/components/Spinner/Spinner.tsx';

interface FileDropzoneProps {
  onDrop: DropzoneOptions['onDrop'];
  isBusy?: boolean;
  text: {
    title: string;
    or?: string;
    browse?: string;
    supports: string;
  };
  Icon: IconType;
  accept: string | string[];
}

function FileDropzone({ onDrop, isBusy = false, text, Icon, accept }: FileDropzoneProps) {
  const { t } = useTranslation();

  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    onDrop,
    maxFiles: 1,
    disabled: isBusy,
    accept: typeof accept === 'string'
      ? { [accept]: [] }
      : accept.reduce((acc, key) => ({ ...acc, [key]: [] }), {}),
  });

  const translateText = {
    browse: t('media.file.dragBrowse'),
    or: t('media.file.dragOr'),
    ...text,
  };

  return (
    <div
      {...getRootProps()}
      className={classNames(
        'border-dashed border-3 border-default-500 hover:border-default-900 rounded-xl cursor-pointer grow flex justify-center',
        {
          'border-default-900': isDragActive && !isDragReject,
        }
      )}
    >
      <input {...getInputProps()} />
      <div className="py-12 flex flex-col items-center justify-center">
        <div className="flex flex-col items-center justify-center min-h-60">
          {isBusy ? (
            <Spinner />
          ) : (
            <>
              <div className="mb-2">
                <Icon size={50} />
              </div>
              <h2 className="text-2xl">{translateText.title}</h2>
              <h3 className="text-2xl">{translateText.or} <span className="text-secondary">{translateText.browse}</span></h3>
              <p className="m-1 text-default-600 text-center px-3">{translateText.supports}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default FileDropzone;
